var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('alarm-list-component',{attrs:{"alarm-type":'alarm'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }